import { render, staticRenderFns } from "./PainelServidor.vue?vue&type=template&id=ea3a233c"
import script from "./PainelServidor.vue?vue&type=script&lang=js"
export * from "./PainelServidor.vue?vue&type=script&lang=js"
import style0 from "./PainelServidor.vue?vue&type=style&index=0&id=ea3a233c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports